var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 60,
    viewBox: "0 0 49 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 57.9999C36.8669 57.9999 46.9583 47.9798 46.9583 35.5388C46.9583 23.0977 36.8669 13.0776 24.5 13.0776C12.1331 13.0776 2.04167 23.0977 2.04167 35.5388C2.04167 47.9798 12.1331 57.9999 24.5 57.9999ZM24.5 59.9999C38.031 59.9999 49 49.0483 49 35.5388C49 22.0292 38.031 11.0776 24.5 11.0776C10.969 11.0776 0 22.0292 0 35.5388C0 49.0483 10.969 59.9999 24.5 59.9999Z",
    fill: "#F59D0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5001 52.1586C33.6357 52.1586 41.1077 44.7537 41.1077 35.5388C41.1077 26.324 33.6357 18.9191 24.5001 18.9191C15.3644 18.9191 7.89247 26.324 7.89247 35.5388C7.89247 44.7537 15.3644 52.1586 24.5001 52.1586ZM24.5001 54.1586C34.7998 54.1586 43.1493 45.8222 43.1493 35.5388C43.1493 25.2555 34.7998 16.9191 24.5001 16.9191C14.2004 16.9191 5.8508 25.2555 5.8508 35.5388C5.8508 45.8222 14.2004 54.1586 24.5001 54.1586Z",
    fill: "#F59D0E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4999 36.3031C24.1348 36.3031 23.7729 35.997 23.7729 35.5388C23.7729 35.3468 23.8378 35.1797 23.9418 35.0494C24.0842 34.8708 24.2859 34.7745 24.4999 34.7745C24.8649 34.7745 25.2269 35.0807 25.2269 35.5388C25.2269 35.997 24.8649 36.3031 24.4999 36.3031ZM24.4999 38.3031C22.9708 38.3031 21.7312 37.0655 21.7312 35.5388C21.7312 34.8881 21.9564 34.2899 22.3332 33.8177C22.8405 33.182 23.6225 32.7745 24.4999 32.7745C26.029 32.7745 27.2685 34.0121 27.2685 35.5388C27.2685 37.0655 26.029 38.3031 24.4999 38.3031Z",
    fill: "#F59D0E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6823 29.133C18.0814 28.7429 18.7277 28.7435 19.126 29.1345L23.1365 33.0713C23.5348 33.4623 23.5341 34.0954 23.135 34.4855C22.7359 34.8757 22.0896 34.875 21.6913 34.4841L17.6808 30.5472C17.2826 30.1563 17.2832 29.5231 17.6823 29.133Z",
    fill: "#F59D0E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1891 25.7681C34.5882 26.1581 34.589 26.7913 34.1909 27.1823L26.9955 34.2485C26.5973 34.6395 25.951 34.6403 25.5518 34.2502C25.1527 33.8602 25.1519 33.227 25.55 32.836L32.7454 25.7699C33.1436 25.3788 33.7899 25.378 34.1891 25.7681Z",
    fill: "#F59D0E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 20.2023C25.0638 20.2023 25.5208 20.65 25.5208 21.2023V23.6398C25.5208 24.1921 25.0638 24.6398 24.5 24.6398C23.9362 24.6398 23.4792 24.1921 23.4792 23.6398V21.2023C23.4792 20.65 23.9362 20.2023 24.5 20.2023Z",
    fill: "#F59D0E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 46.4379C25.0638 46.4379 25.5208 46.8856 25.5208 47.4379V49.8754C25.5208 50.4277 25.0638 50.8754 24.5 50.8754C23.9362 50.8754 23.4792 50.4277 23.4792 49.8754V47.4379C23.4792 46.8856 23.9362 46.4379 24.5 46.4379Z",
    fill: "#F59D0E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.11978 35.5389C9.11978 34.9866 9.57682 34.5389 10.1406 34.5389H12.582C13.1458 34.5389 13.6028 34.9866 13.6028 35.5389C13.6028 36.0912 13.1458 36.5389 12.582 36.5389H10.1406C9.57682 36.5389 9.11978 36.0912 9.11978 35.5389Z",
    fill: "#F59D0E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3971 35.5389C35.3971 34.9866 35.8541 34.5389 36.4179 34.5389H38.8593C39.4231 34.5389 39.8801 34.9866 39.8801 35.5389C39.8801 36.0912 39.4231 36.5389 38.8593 36.5389H36.4179C35.8541 36.5389 35.3971 36.0912 35.3971 35.5389Z",
    fill: "#F59D0E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1041 2H19.896C19.3395 2 18.8884 2.44189 18.8884 2.98698C18.8884 3.53208 19.3395 3.97397 19.896 3.97397H29.1041C29.6605 3.97397 30.1116 3.53208 30.1116 2.98698C30.1116 2.44189 29.6605 2 29.1041 2ZM19.896 0C18.2119 0 16.8467 1.33732 16.8467 2.98698C16.8467 4.63665 18.2119 5.97397 19.896 5.97397H29.1041C30.7881 5.97397 32.1533 4.63665 32.1533 2.98698C32.1533 1.33732 30.7881 0 29.1041 0H19.896Z",
    fill: "#F59D0E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9744 4.62189C20.5382 4.62189 20.9952 5.0696 20.9952 5.62189V11.4968C20.9952 12.0491 20.5382 12.4968 19.9744 12.4968C19.4106 12.4968 18.9536 12.0491 18.9536 11.4968V5.62189C18.9536 5.0696 19.4106 4.62189 19.9744 4.62189ZM29.0255 4.62189C29.5893 4.62189 30.0463 5.0696 30.0463 5.62189V11.4968C30.0463 12.0491 29.5893 12.4968 29.0255 12.4968C28.4617 12.4968 28.0047 12.0491 28.0047 11.4968V5.62189C28.0047 5.0696 28.4617 4.62189 29.0255 4.62189Z",
    fill: "#F59D0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/Time.7c1cf5ec1c240cb1bca505ff0392dca4.svg";
export { ForwardRef as ReactComponent };